import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {AddClientStoreForm} from "./AddClientStoreForm";

class AddClientStoreModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newClientAdAccountId) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newClientAdAccountId);
    }

    // Lo mismo con cliente fijo o sin él: el modal VINCULA una tienda (una que la agencia ya tiene o
    // una que se conecta ahí mismo). «Agregar nueva Tienda» sugería que siempre se creaba una.
    renderHeaderTitle() {
        return this.props.t('add_client_store_modal.title');
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}>{this.renderHeaderTitle()}</ModalHeader>
                <AddClientStoreForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                        clientId={this.props.clientId}
                                        channel={this.props.channel}
                                        platform={this.props.platform}
                                        storeId={this.props.storeId}
                                        clientName={this.props.clientName}/>
            </Modal>
        );
    }
}

// `forwardRef` para que los que lo abren por `ref.toggle()` sigan llegando a la instancia de la
// clase y no al HOC de i18n.
export const AddClientStoreModal = withTranslation(undefined, {withRef: true})(AddClientStoreModalClass);
